import countryCodes from 'constants/phone-country-code';

export const addPhoneCountryCode = (
  countryCode: any,
  userPhone: string | undefined,
): string | undefined => {
  if (userPhone) return userPhone;
  const phoneCode = countryCodes.filter(
    (codeValue: any) => countryCode === codeValue.code,
  )[0];
  return phoneCode ? phoneCode.value : '';
};

export const stripOffCountryCode = (phone = ''): string => {
  let stripped = phone;
  countryCodes.forEach((c) => {
    if (phone.startsWith(c.value)) {
      stripped = phone.replace(c.value, '');
    }
  });

  return stripped;
};
